"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fdc3StandardIntents = exports.Fdc3IntentConfiguration = exports.ViewResearchIntent = exports.ViewQuoteIntent = exports.ViewProfileIntent = exports.ViewOrdersIntent = exports.ViewNewsIntent = exports.ViewInteractionsIntent = exports.ViewInstrumentIntent = exports.ViewHoldingsIntent = exports.ViewContactIntent = exports.ViewChartIntent = exports.ViewAnalysisIntent = exports.StartEmailIntent = exports.StartChatIntent = exports.StartCallIntent = void 0;
const Fdc3Context_1 = require("./Fdc3Context");
exports.StartCallIntent = 'StartCall';
exports.StartChatIntent = 'StartChat';
exports.StartEmailIntent = 'StartEmail';
exports.ViewAnalysisIntent = 'ViewAnalysis';
exports.ViewChartIntent = 'ViewChart';
exports.ViewContactIntent = 'ViewContact';
exports.ViewHoldingsIntent = 'ViewHoldings';
exports.ViewInstrumentIntent = 'ViewInstrument';
exports.ViewInteractionsIntent = 'ViewInteractions';
exports.ViewNewsIntent = 'ViewNews';
exports.ViewOrdersIntent = 'ViewOrders';
exports.ViewProfileIntent = 'ViewProfile';
exports.ViewQuoteIntent = 'ViewQuote';
exports.ViewResearchIntent = 'ViewResearch';
exports.Fdc3IntentConfiguration = {
    [exports.StartCallIntent]: {
        contexts: [Fdc3Context_1.ContactContextKey, Fdc3Context_1.ContactListContextKey, Fdc3Context_1.NothingContextKey],
        icon: 'call',
    },
    [exports.StartChatIntent]: {
        contexts: [
            Fdc3Context_1.ContactContextKey,
            Fdc3Context_1.ContactListContextKey,
            Fdc3Context_1.ChatInitSettingsContextKey,
            Fdc3Context_1.NothingContextKey,
        ],
        icon: 'chat',
    },
    [exports.StartEmailIntent]: {
        contexts: [Fdc3Context_1.EmailContextKey],
        icon: 'mail',
    },
    [exports.ViewAnalysisIntent]: {
        contexts: [
            Fdc3Context_1.InstrumentContextKey,
            Fdc3Context_1.OrganizationContextKey,
            Fdc3Context_1.PortfolioContextKey,
            Fdc3Context_1.NothingContextKey,
        ],
        icon: 'spark-line',
    },
    [exports.ViewChartIntent]: {
        contexts: [
            Fdc3Context_1.ChartContextKey,
            Fdc3Context_1.InstrumentContextKey,
            Fdc3Context_1.InstrumentListContextKey,
            Fdc3Context_1.PortfolioContextKey,
            Fdc3Context_1.PositionContextKey,
            Fdc3Context_1.NothingContextKey,
        ],
        icon: 'pie-chart',
    },
    [exports.ViewContactIntent]: {
        contexts: [Fdc3Context_1.ContactContextKey, Fdc3Context_1.NothingContextKey],
        icon: 'person',
    },
    [exports.ViewHoldingsIntent]: {
        contexts: [
            Fdc3Context_1.InstrumentContextKey,
            Fdc3Context_1.InstrumentListContextKey,
            Fdc3Context_1.OrganizationContextKey,
            Fdc3Context_1.NothingContextKey,
        ],
        icon: 'building',
    },
    [exports.ViewInstrumentIntent]: {
        contexts: [Fdc3Context_1.InstrumentContextKey, Fdc3Context_1.NothingContextKey],
        icon: 'money',
    },
    [exports.ViewInteractionsIntent]: {
        contexts: [Fdc3Context_1.ContactContextKey, Fdc3Context_1.InstrumentContextKey, Fdc3Context_1.OrganizationContextKey, Fdc3Context_1.NothingContextKey],
        icon: 'interactions',
    },
    [exports.ViewNewsIntent]: {
        contexts: [
            Fdc3Context_1.CountryContextKey,
            Fdc3Context_1.InstrumentContextKey,
            Fdc3Context_1.InstrumentListContextKey,
            Fdc3Context_1.OrganizationContextKey,
            Fdc3Context_1.PortfolioContextKey,
            Fdc3Context_1.NothingContextKey,
        ],
        icon: 'news',
    },
    [exports.ViewOrdersIntent]: {
        contexts: [Fdc3Context_1.ContactContextKey, Fdc3Context_1.InstrumentContextKey, Fdc3Context_1.OrganizationContextKey, Fdc3Context_1.NothingContextKey],
        icon: 'order',
    },
    [exports.ViewProfileIntent]: {
        contexts: [Fdc3Context_1.ContactContextKey, Fdc3Context_1.OrganizationContextKey, Fdc3Context_1.NothingContextKey],
        icon: 'badge',
    },
    [exports.ViewQuoteIntent]: {
        contexts: [Fdc3Context_1.InstrumentContextKey, Fdc3Context_1.NothingContextKey],
        icon: 'quote',
    },
    [exports.ViewResearchIntent]: {
        contexts: [Fdc3Context_1.ContactContextKey, Fdc3Context_1.InstrumentContextKey, Fdc3Context_1.OrganizationContextKey, Fdc3Context_1.NothingContextKey],
        icon: 'science',
    },
};
exports.Fdc3StandardIntents = Object.keys(exports.Fdc3IntentConfiguration);
